<script lang="ts">
  import { Colors } from '../../ui/colors'
  import { Type } from '../../ui/theme'
</script>

<span style="display: inline-flex; align-items: center; gap: 4px;">
  <span style="width: 6px; height: 6px; border-radius: 3px; background-color: {Colors.success};"></span>
  <span style="color: {Colors.success}; {Type.caption}; font-weight: 700;">LIVE</span>
</span>
